import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { buildBreadcrumbs } from '../../../config/navigation/breadcrumbs';
import { accountDetailAtom } from '../state/accountAtoms';
import { CAMPAIGN_COPY } from '../constants/campaignCopy';
import { DEFAULT_ACCOUNT_TAB } from '../constants/accountConstants';
import { buildAccountRoute } from '../utils/businessFunctionRoutes';

function resolveParentAccountName(accountId, searchParams, cachedAccount) {
  const fromQuery = searchParams.get('accountName') || searchParams.get('name') || '';
  if (fromQuery) return fromQuery;

  if (cachedAccount && accountId && String(cachedAccount.id) === String(accountId)) {
    return cachedAccount.name || '';
  }

  return '';
}

/**
 * Breadcrumb trail for the business service (workspace) detail page.
 * Middle segment links to the parent business function's Business Services tab.
 */
export default function useWorkspaceBreadcrumbs(accountId, workspaceName) {
  const [searchParams] = useSearchParams();
  const cachedAccount = useRecoilValue(accountDetailAtom);
  const accountName = resolveParentAccountName(accountId, searchParams, cachedAccount);

  return useMemo(
    () => buildBreadcrumbs([
      {
        label: accountName || 'Account',
        href: buildAccountRoute(accountId, {
          name: accountName,
          tab: DEFAULT_ACCOUNT_TAB,
        }),
      },
      { label: workspaceName || CAMPAIGN_COPY.defaultName },
    ]),
    [accountId, accountName, workspaceName]
  );
}
